import template from './forgot_password.html';
import controller from './forgot_password.controller';
import './forgot_password.scss';

let forgotPasswordComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default forgotPasswordComponent;



// WEBPACK FOOTER //
// ./client/app/components/forgot_password/forgot_password.component.js